
import hangye from '@/data/hangye.json'
import changye from '@/data/changye.json'
import qiyexingzhi from '@/data/qiyexingzhi.json'
export default {
    data() {
        return {
            hangyeData: hangye.data,
            changyeData: changye.root.children,
            qiyexingzhiData: qiyexingzhi.data,
            activeIndex: ''
        }
    },
    methods: {
        getValByTopic1(selectValue, i) {
            this.$refs.elMenuRef.close('-1')
            $('.topic-item1').removeClass('active')
            $(event.currentTarget).addClass('active')
            $('#root-item1').addClass('active')
            this.$emit('doSelect1', selectValue)
        },
        getValByTopic2(selectValue) {
            this.$refs.elMenuRef.close('-1')
            $('.topic-item1').removeClass('active')
            $(event.currentTarget).addClass('active')
            $('#root-item1').addClass('active')
            this.$emit('doSelect2', selectValue)
        },
        getValByTopic3(selectValue) {
            this.$refs.elMenuRef.close('-1')
            $('.topic-item1').removeClass('active')
            $(event.currentTarget).addClass('active')
            $('#root-item1').addClass('active')
            this.$emit('doSelect3', selectValue)
        },

        getChanYeValByTopic1(selectValue) {
            this.$refs.elMenuRef1.close('-1')
            $('.topic-item2').removeClass('active')
            $(event.currentTarget).addClass('active')
            $('#root-item2').addClass('active')
            this.$emit('doChanyeSelect1', selectValue)
        },
        getChanYeValByTopic2(selectValue) {
            this.$refs.elMenuRef1.close('-1')
            $('.topic-item2').removeClass('active')
            $(event.currentTarget).addClass('active')
            $('#root-item2').addClass('active')
            this.$emit('doChanyeSelect2', selectValue)
        },

        getQiYeByTopic1(selectValue) {
            this.$refs.elMenuRef2.close('-1')
            $('.topic-item3').removeClass('active')
            $(event.currentTarget).addClass('active')
            $('#root-item3').addClass('active')
            this.$emit('doQiYeSelect1', selectValue)
        },

        getQiYeByTopic2(selectValue) {
            this.$refs.elMenuRef2.close('-1')
            $('.topic-item3').removeClass('active')
            $(event.currentTarget).addClass('active')
            $('#root-item3').addClass('active')
            this.$emit('doQiYeSelect2', selectValue)
        },
    }
}
